import { TestimonialType } from '../types';

export const testimonials: TestimonialType[] = [
  {
    id: 'sarah',
    name: 'Sarah W.',
    content: 'My kids were thrilled to get a video from Santa! It made their Christmas magical!',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100&h=100'
  },
  {
    id: 'david',
    name: 'David L.',
    content: 'I shared a Santa video with my colleagues, and it was the highlight of our holiday party!',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=100&h=100'
  },
  {
    id: 'emily',
    name: 'Emily R.',
    content: 'The process was so simple, and the video quality was amazing. Highly recommend!',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=100&h=100'
  },
  {
    id: 'michael',
    name: 'Michael T.',
    content: "Santa's message was so personal and festive—it brought happy tears to my mom's eyes!",
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=100&h=100'
  }
];